import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sendPostRequest } from '@vh/services/PDService';

const CallSlice = createSlice({
  name: 'call',
  initialState: {
    loadingBotResponse: false,
    loadingUserRequest: false,
  },
  reducers: {
    setLoadingBotResponse: (state, action) => {
      state.loadingBotResponse = action.payload;
    },
    setLoadingUserResponse: (state, action) => {
      state.loadingUserRequest = action.payload;
    },
  },
});

export const loadingUserRequestSelector = (state) =>
  state.call.loadingUserRequest;
export const loadingBotResponseSelector = (state) =>
  state.call.loadingBotResponse;

export const { setLoadingBotResponse, setLoadingUserResponse } =
  CallSlice.actions;
export default CallSlice;
